import { create, useStore } from "zustand";
import { immer } from "zustand/middleware/immer";
import { useContext } from "react";
import { createZustandContext } from "../ZustandContextPattern";
import { initialLoginUserInfo, LoginUserInfo } from "../../types/LoginUserInfo";
import { getLoginInfo } from "../../common/ApiUtil";
import * as Urls from '../../common/Urls';

export interface AppComponentState{
    loginUser :LoginUserInfo,
    header:{
        title:string,
        userName:string,
        setTitle: (value:string) => void,
        setUserName:(value:string) => void,
        logout:() => void,
    },
    progress :{
        isDisplay :boolean,
        show:() => void,
        hide:() => void,
    },
    messageBox :{
        isDisplay : boolean,
        isPopupInitialized :boolean,
        title : string,
        message : string,
        positiveButtonTitle : string,
        onPositiveButtonClick ?: () => void,
        nagativeButtonTitle : string,
        onNagativeButtonClick ?: () => void,
        cancelButtonTitle : string,
        onCancelButtonClick ?: () => void,

        popupInitialized : () => void,
        show:(
                title:string, message:string, 
                positiveButtonTitle ?: string,
                onPositiveButtonClick ?: ()=>void, 
                nagativeButtonTitle ?: string,
                onNagativeButtonClick ?: ()=>void,
                cancelButtonTitle ?: string,
                onCancelButtonClick ?: ()=>void,) => void,
        hide:() => void,
    },
    thunkGetUserInfo : () => void,
}

export const {context: AppComponentStoreContext, useStore: useAppComponentStore} = 
    createZustandContext<AppComponentState>((set) => ({
        loginUser:initialLoginUserInfo,
        header :{
            title:"",
            userName:"",
            /**
             * タイトルのセット
             * @param value 
             * @returns 
             */
            setTitle: (value) => set((state) => {
                state.header.title = value;
            }),
            /**
             * ユーザー名のセット
             * @param value 
             * @returns 
             */
            setUserName: (value) => set((state) => {
                state.header.userName = value;
            })
            ,
            /**
             * ログアウト
             */
            logout: () => {
                location.href= Urls.URL_LOGIN + "?logout";
            }
        },
        progress :{
            isDisplay:false,
            /**
             * プログレスバー表示
             * @returns 
             */
            show: () => set((state) => {
                state.progress.isDisplay = true;
            }),
            hide: () => set((state) => {
                state.progress.isDisplay = false;
            })
        },
        messageBox :{
            isDisplay : false,
            isPopupInitialized : false,
            title : "",
            message : "",
            positiveButtonTitle : "",
            nagativeButtonTitle : "" ,
            cancelButtonTitle :"",

            /**
             * ポップアップ初期化
             * @returns 
             */
            popupInitialized : () => set((state) =>{
                state.messageBox.isPopupInitialized = true;
            }),
            /**
             * メッセージボックス表示
             */
            show:(
                    title:string, message:string, 
                    positiveButtonTitle ?: string,
                    onPositiveButtonClick ?: ()=>void, 
                    nagativeButtonTitle ?: string,
                    onNagativeButtonClick ?: ()=>void,
                    cancelButtonTitle ?: string,
                    onCancelButtonClick ?: ()=>void) => set((state) => {
                
                state.messageBox.isDisplay = true;
                state.messageBox.title = title;
                state.messageBox.message = message;
                state.messageBox.positiveButtonTitle = positiveButtonTitle;
                state.messageBox.onPositiveButtonClick = onPositiveButtonClick;
                state.messageBox.nagativeButtonTitle = nagativeButtonTitle;
                state.messageBox.onNagativeButtonClick = onNagativeButtonClick;
                state.messageBox.cancelButtonTitle = cancelButtonTitle;
                state.messageBox.onCancelButtonClick = onCancelButtonClick;
            }),
            hide:() => set((state) => {
                state.messageBox.isDisplay = false;
            })
        },
        /**
         * ログインユーザー情報の取得
         * @returns 
         */
        thunkGetUserInfo : async() => {
            const data = await getLoginInfo();

            set((state) => {
                state.loginUser = data.user;
            })
        }
    }));